<template>
    <div class="image-list" v-if="isInit">
        <el-form ref="form" :model="field" label-width="120px">
            <el-form-item
                class="input-row"
                v-for="(item, index) in field.def_val"
                :key="index"
                :label="`${field.desc}(${index + 1})`"
                :prop="`def_val[${index}].val`"
                :rules="fieldRules">
                    <el-input class="field-input" v-model="item.val" :placeholder="`请填写'${field.desc}'的内容`"></el-input>
                    <el-button class="remove-btn" @click="remove(index)">删除</el-button>
            </el-form-item>
            <el-form-item>
                <el-button class="add-btn" @click="add">+</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import moment from 'moment';

export default {
    name: 'image-list',
    props: ['field', 'autoInit'],
    data() {
        return {
            // resField: this.field,
            fieldRules: {
                required: this.field.require,
                message: `请填写'${this.field.desc}'的内容`,
                trigger: 'blur'
            },
            isInit: this.autoInit
            // fieldRules: {
            //     required: true,
            //     message: '12sddfasdf',
            //     trigger: 'blur'
            // }
        }
    },
    components: {
    },
    watch: {
        'field'(val) {
            if (!this.field.def_val.length) {
                this.add();
            }
        }
    },
    methods: {
        initData() {
            this.isInit = true;
        },
        add() {
            this.field.def_val.push({
                val: ''
            });
        },
        remove(index) {
            this.field.def_val.splice(index, 1);
        },
        fieldBeReady() {
            // 确认组件是否就绪
            return this.$refs['form'];
        },
        getResField() {
            let isValidate = false;
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    isValidate = true;
                } else {
                    isValidate = false;
                }
            });
            if (!isValidate) {
                return;
            }
            return this.field;
        }
    },
    computed: {
    },
    mounted() {
    }
}
</script>
<style lang="less">
    @import (reference) '../../styles/public.less';
    .image-list {
        .label-item();
        .field-input {
            width: 85%;
        }
        .remove-btn {
            float: right;
        }
        .add-btn {
            margin-top: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/compEditForm/imageList.vue